import React from 'react';
import {useTranslation} from 'react-i18next';
import AccordionItem from '../../../../../../ui/components/AccordionItem';
import FontAndBackgroundColorPicker, {COLOR_FIELDS} from '../../../common/fontAndBackgroundColorPicker';
import {IQuestionElements} from '../../../../../../incase-domain/elements/question';
import DebouncedNumberInput from '../../../common/debounced/DebounceNumberInput';
import {ELEMENT} from '../../../../../../incase-domain/elements/base/ElementTypes';

interface CommentAdvancedOptionsProps {
    highlightedElement: IQuestionElements;
    highlightedElementChangeHandler: {
        single: (field: keyof IQuestionElements | string, value: unknown) => void;
    };
    commentColorFields: COLOR_FIELDS[];
}

export default function CommentAdvancedOptions(props: CommentAdvancedOptionsProps): JSX.Element {
    const {highlightedElement, highlightedElementChangeHandler, commentColorFields} = props;

    const {t} = useTranslation();

    return (
        <AccordionItem header={<div className="u-flex u-h-between u-v-center">{t('designSidepanel.comment')}</div>}>
            <div className="l-group--form">
                <div className="l-group__item u-flex u-flex-col u-gap-2 u-pb-2">
                    <DebouncedNumberInput
                        label={t('designSidepanel.fontSize')}
                        value={highlightedElement.commentFontSize || 1}
                        onChange={(newValue) => highlightedElementChangeHandler.single('commentFontSize', newValue)}
                        step={0.1}
                        min={0.1}
                    />
                    {highlightedElement.type !== ELEMENT.QUESTION && (
                        <FontAndBackgroundColorPicker
                            highlightedElement={highlightedElement}
                            highlightedElementChangeHandler={highlightedElementChangeHandler}
                            colorFields={commentColorFields}
                        />
                    )}
                </div>
            </div>
        </AccordionItem>
    );
}
